import React from 'react';
import {
  useState,
} from 'react';
import {
  Card,
  TextStyle,
  Stack,
  ResourceItem,
  ResourceList,
  Thumbnail
} from '@shopify/polaris';
import { GenieTag } from '../../../components/GenieTag';
import Pager from './Pager';
import ResourceCounts from './ResourceCounts';

function resolveItemIds({ id }) {
  return id;
}

function ProductListView(props) {

  const [showTags, setShowTags] = useState(true);

  function onResourceItemClick(id) {

    var index = props.selectedItems.indexOf(id);

    if (index === -1) {
      let newSelected = [...props.selectedItems, id];
      props.onSelectionChange(newSelected);
    }
    else {
      let newSelected = [
        ...props.selectedItems.slice(0, index),
        ...props.selectedItems.slice(index + 1)
      ];
      props.onSelectionChange(newSelected);
    }
  }

  const resourcesToRender = props.resources.map(_ => {
    return {
      ..._,
      selected: props.selectedItems.includes(_.id),
      onItemClick: (__) => { onResourceItemClick(_.id) }
    }
  });

  function renderItem(item) {
    const { id, image, title, tags, onItemClick } = item;
    var tagElements = tags.map(_ => <GenieTag selectable={false}>{_}</GenieTag>);

    return (
      <ResourceItem
        id={id}
        key={id}
        onClick={onItemClick}
        media={
          <Thumbnail
            size="large"
            source={image}
          />}
        accessibilityLabel={`View details for ${title}`}>
        <Stack vertical alignment="leading" distribution="leading">
          <Stack.Item fill>
            <TextStyle variation="strong">{title}</TextStyle>
          </Stack.Item>
          {showTags &&
            <Stack.Item>
              <Stack alignment="leading" distribution="leading" spacing="tight">
                {tagElements}
              </Stack>
            </Stack.Item>}
        </Stack>
      </ResourceItem>
    );
  }

  return (
    <Card title="Products"
      actions={[
        {
          content: showTags ? 'Hide Product Tags' : 'Show Product Tags',
          onAction: () => setShowTags(!showTags)
        },
      ]}>
      <Card.Section>
        <ResourceCounts
          totalResourceCount={props.totalResources}
          matchingResourceCount={props.totalMatchingResources}
          currentResourceCount={resourcesToRender.length} />
      </Card.Section>
      <Pager
        currentPage={props.currentPage}
        totalResources={props.totalMatchingResources}
        disabled={props.isLoading}
        onPrevious={props.onRequestPreviousPage}
        onNext={props.onRequestNextPage}
      />
      <br />
      <ResourceList
        selectable
        hasMoreItems={(props.currentPage * 50) < props.totalMatchingResources}
        isFiltered={props.totalMatchingResources < props.totalResources}
        totalItemsCount={props.totalMatchingResources}
        loading={props.isLoading}
        items={props.isLoading ? [] : resourcesToRender}
        renderItem={renderItem}
        resolveItemId={resolveItemIds}
        selectedItems={props.allSelected ? "All" : props.selectedItems}
        onSelectionChange={props.onSelectionChange}
        promotedBulkActions={props.promotedBulkActions}
        sortValue="DATE_CREATED_DESC"
        sortOptions={[
          { label: 'Created (newest first)', value: 'DATE_CREATED_DESC' },
        ]}
        filterControl={props.filterControl}
      />
      <Pager
        currentPage={props.currentPage}
        totalResources={props.totalMatchingResources}
        disabled={props.isLoading}
        onPrevious={props.onRequestPreviousPage}
        onNext={props.onRequestNextPage}
      />
      <br />
    </Card>
  );

}

export default ProductListView;